import { useEffect } from 'react';

export enum HotjarEvent {
    USER_PERSONA_SURVEY = 'user_persona_survey'
}

function isValidDate(date) {
    return date instanceof Date;
}

function isDateOlderThan(date, days) {
    const now = new Date();
    return now.getDate() - date.getDate() >= days
}

export function useTriggerHotjarSurvey(event: HotjarEvent) {
    useEffect(() => {
        // Our HotJar is in GTM, we triggger events there through dataLayer
        window.dataLayer = window.dataLayer || [];
        
        const timeId = setTimeout(() => {
            const localValue = window.localStorage.getItem(event);
            const date = new Date(localValue)

            if (!localValue || !isValidDate(date) || isDateOlderThan(date, 7)) {
                window.dataLayer.push({event: event});
                window.localStorage.setItem(event, Date.now().toString())
            }
        }, 3000)

        return () => {
            clearTimeout(timeId)
        }
    }, [])
}